export default __webpack_public_path__ + "static/media/logo-microgen-black.4d8fc822.png";